<template>
    <div class="table-action-btn" title="Редактирование заявки">     
        <svg width="16" height="16" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M126.101 61.1968C125.959 60.9873 124.693 59.1231 124.011 58.2331C120.826 54.0786 113.368 44.3493 103.085 35.8386C90.2085 25.181 77.0585 19.7773 64 19.7773C50.9415 19.7773 37.7915 25.1813 24.915 35.8388C14.6323 44.3493 7.17375 54.0786 3.9885 58.2336C3.30675 59.1233 2.0415 60.9871 1.89925 61.1968L0 63.9998L1.89875 66.8028C2.04075 67.0123 3.30625 68.8771 3.9885 69.7673C7.1735 73.9218 14.6322 83.6511 24.9147 92.1618C37.7912 102.819 50.9415 108.223 64 108.223C77.0585 108.223 90.2085 102.819 103.085 92.1616C113.368 83.6508 120.826 73.9216 124.011 69.7671C124.693 68.877 125.959 67.0125 126.101 66.8025L128 63.9996L126.101 61.1968ZM64 98.2288C47.0915 98.2288 29.6512 86.7123 12.1608 64.0001C29.6515 41.2873 47.0915 29.771 64 29.771C80.9088 29.771 98.349 41.2875 115.839 64.0001C98.3487 86.7126 80.9088 98.2288 64 98.2288Z" fill="black"/>
            <path d="M64.0005 73.7445C69.3819 73.7445 73.7445 69.382 73.7445 64.0005C73.7445 58.6191 69.3819 54.2565 64.0005 54.2565C58.619 54.2565 54.2565 58.6191 54.2565 64.0005C54.2565 69.382 58.619 73.7445 64.0005 73.7445Z" fill="black"/>
            <path d="M64 35.5173C48.2947 35.5173 35.5175 48.2943 35.5175 63.9998C35.5175 79.7051 48.2945 92.4823 64 92.4823C79.7055 92.4823 92.4825 79.7051 92.4825 63.9998C92.4825 48.2943 79.7052 35.5173 64 35.5173ZM64 82.4883C53.8052 82.4883 45.5115 74.1943 45.5115 63.9998C45.5115 53.8053 53.8052 45.5113 64 45.5113C74.1947 45.5113 82.4885 53.8051 82.4885 63.9998C82.4885 74.1943 74.1947 82.4883 64 82.4883Z" fill="black"/>
        </svg>
    </div>
</template>

<script>

export default {
    name: 'Btn_edit',

}

</script>

<style>
    .table-action-btn {
        display: inline-block;
        cursor: pointer;
    }
</style>